import React from 'react';
import { TabsContainer } from '../shared/TabsContainer';

export interface TabConfig {
    id: string;
    label: string;
    icon?: string;
    separator?: boolean; // If true, adds a separator after this tab
    rightAlign?: boolean; // If true, this tab and following tabs will be right-aligned
}

interface AdminTabsProps {
    tabs: TabConfig[];
    activeTab: string;
    onTabChange: (tabId: string) => void;
}

/**
 * AdminTabs component - Renders tab navigation for admin pages
 * Accepts tab configuration and handles tab switching
 */
const AdminTabs: React.FC<AdminTabsProps> = ({ tabs, activeTab, onTabChange }) => {
    return (
        <TabsContainer>
            {tabs.map((tab) => (
                <React.Fragment key={tab.id}>
                    {tab.rightAlign && <li style={{ marginLeft: 'auto' }} />}
                    <li>
                        <a
                            className={`tab-btn ${activeTab === tab.id ? 'active' : ''}`}
                            onClick={(e) => {
                                e.preventDefault();
                                onTabChange(tab.id);
                            }}
                        >
                            {tab.icon && <i className={`fas ${tab.icon}`} style={{ marginRight: '0.5rem' }}></i>}
                            {tab.label}
                        </a>
                    </li>
                    {tab.separator && (
                        <li
                            style={{ marginLeft: '0.5rem', marginRight: '0.5rem', borderLeft: '1px solid #ddd', height: '24px', alignSelf: 'center' }}
                        />
                    )}
                </React.Fragment>
            ))}
        </TabsContainer>
    );
};

export default AdminTabs;
